module.exports = __webpack_public_path__ + "img/retail.81b2960f.svg";